var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "simple__block" }, [
    _c("h3", { staticClass: "h5" }, [_vm._v("Список новых заказов")]),
    _vm._v(" "),
    _c("table", { staticClass: "table table__new__orders" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [
          _vm._m(1),
          _vm._v(" "),
          _c("td", [
            _c(
              "div",
              {
                staticClass:
                  "table__extras d-flex justify-content-sm-end justify-content-lg-start align-items-center",
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "tooltip__block tooltip__top tooltip__block_simple",
                  },
                  [
                    _c("span", { staticClass: "tooltip__block_trigger" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M10 17c.12 0 .3-.04.49-.13C14.64 14.79 16 13.72 16 11.2V5.92c0-.76-.33-1.01-.98-1.27a118.5 118.5 0 00-4.37-1.55 2.15 2.15 0 00-1.3 0c-.83.26-3.55 1.22-4.38 1.55-.65.25-.97.51-.97 1.27v5.28c0 2.52 1.42 3.47 5.51 5.67.19.1.37.13.49.13zm-.77-3.54c-.26 0-.46-.1-.67-.35l-2.08-2.46a.72.72 0 01-.18-.46c0-.35.28-.6.61-.6.22 0 .4.07.57.28L9.2 12l3.33-5.14c.15-.22.34-.33.54-.33.33 0 .65.22.65.56 0 .15-.1.32-.18.47L9.85 13.1a.72.72 0 01-.62.35z",
                              fill: "#2A9C57",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(2),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "tooltip__block tooltip__top tooltip__block_simple",
                  },
                  [
                    _c("span", { staticClass: "tooltip__block_trigger" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M13.92 7.35l2.59-1.45c-.11-.11-.24-.2-.4-.29l-4.84-2.74A2.58 2.58 0 0010 2.5c-.42 0-.84.13-1.26.37l-1.37.78 6.55 3.7zM10 9.57l2.93-1.66L6.4 4.2 3.9 5.62c-.16.08-.29.17-.4.28L10 9.57zm.48 7.93c.06-.01.1-.04.16-.07l5.37-3.04c.65-.37.99-.75.99-1.74V7.24c0-.2-.01-.36-.05-.5l-6.47 3.68v7.08zm-.96 0v-7.08L3.05 6.73c-.04.15-.05.3-.05.5v5.42c0 .99.35 1.37 1 1.74l5.36 3.04c.05.03.1.06.16.07z",
                              fill: "#2A9C57",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(3),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "tooltip__block tooltip__top tooltip__block_simple",
                  },
                  [
                    _c("span", { staticClass: "tooltip__block_trigger" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M9.34 10.2V6.43H8.26c-1.18 0-1.8-.74-1.8-1.48 0-.76.57-1.2 1.34-1.2.89 0 1.57.66 1.57 1.77v.91h1.26v-.9c0-1.12.69-1.79 1.58-1.79.76 0 1.34.45 1.34 1.2s-.65 1.49-1.81 1.49h-1.07v3.79h5.07c.82 0 1.26-.33 1.26-1.12V7.53c0-.8-.44-1.11-1.26-1.11h-1.62c.45-.4.72-.94.72-1.56 0-1.37-1.13-2.36-2.54-2.36-1.06 0-1.93.58-2.3 1.6a2.35 2.35 0 00-2.3-1.6c-1.41 0-2.54.99-2.54 2.36 0 .62.26 1.16.71 1.56h-1.6c-.8 0-1.27.31-1.27 1.11V9.1c0 .8.44 1.12 1.27 1.12h5.07zm0 7.3v-6.52H4.02v4.71c0 1.18.72 1.81 1.93 1.81h3.4zm1.33-6.52v6.52h3.38c1.21 0 1.93-.63 1.93-1.81v-4.71h-5.31z",
                              fill: "#2A9C57",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(4),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "tooltip__block tooltip__top tooltip__block_simple",
                  },
                  [
                    _c("span", { staticClass: "tooltip__block_trigger" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M14.93 9.39h1.6c.98 0 1.47-.5 1.47-1.54v-3.3C18 3.5 17.51 3 16.53 3h-1.6c-.98 0-1.47.5-1.47 1.54v3.3c0 1.04.49 1.55 1.47 1.55zm-11.46 0h1.6c.98 0 1.47-.5 1.47-1.54v-3.3C6.54 3.5 6.05 3 5.07 3h-1.6C2.49 3 2 3.5 2 4.54v3.3c0 1.04.49 1.55 1.47 1.55zm5.73 0h1.6c.98 0 1.47-.5 1.47-1.54v-3.3C12.27 3.5 11.78 3 10.8 3H9.2c-.98 0-1.47.5-1.47 1.54v3.3c0 1.04.49 1.55 1.47 1.55zM3.47 17h1.6c.98 0 1.47-.5 1.47-1.54v-3.3c0-1.05-.49-1.55-1.47-1.55h-1.6c-.98 0-1.47.5-1.47 1.54v3.3C2 16.5 2.49 17 3.47 17zm5.73 0h1.6c.98 0 1.47-.5 1.47-1.54v-3.3c0-1.05-.49-1.55-1.47-1.55H9.2c-.98 0-1.47.5-1.47 1.54v3.3c0 1.05.49 1.55 1.47 1.55zm5.73 0h1.6c.98 0 1.47-.5 1.47-1.54v-3.3c0-1.05-.49-1.55-1.47-1.55h-1.6c-.98 0-1.47.5-1.47 1.54v3.3c0 1.05.49 1.55 1.47 1.55z",
                              fill: "#2A9C57",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(5),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("td", { staticStyle: { "white-space": "nowrap" } }, [
            _vm._v("24 Май 2020"),
          ]),
          _vm._v(" "),
          _c("td", [
            _c(
              "div",
              { staticClass: "table__actions d-flex justify-content-end" },
              [
                _c("a", { attrs: { href: "order_edit.html", title: "Edit" } }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M17.25 3.87l.55-.59c.27-.27.27-.66 0-.92l-.17-.2c-.23-.24-.6-.2-.85.05l-.56.57 1.03 1.1zm-8.72 8.24l1.48-.68 6.7-6.98-1.05-1.07-6.69 6.99-.68 1.48c-.06.14.1.32.24.26zM5.38 18h8.9c1.37 0 2.16-.82 2.16-2.46V6.73L15.2 8.01v7.47c0 .83-.42 1.24-.94 1.24H5.4c-.75 0-1.18-.41-1.18-1.24V6.5c0-.82.43-1.25 1.18-1.25h6.56l1.22-1.27h-7.8C3.8 3.97 3 4.79 3 6.42v9.12C3 17.18 3.8 18 5.38 18z",
                          fill: "#06C",
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("a", { attrs: { href: "#", title: "Remove" } }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z",
                          fill: "#515154",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _vm._m(6),
          _vm._v(" "),
          _c("td", [
            _c(
              "div",
              {
                staticClass:
                  "table__extras d-flex justify-content-sm-end justify-content-lg-start align-items-center",
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "tooltip__block tooltip__top tooltip__block_simple",
                  },
                  [
                    _c("span", { staticClass: "tooltip__block_trigger" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M10 17c.12 0 .3-.04.49-.13C14.64 14.79 16 13.72 16 11.2V5.92c0-.76-.33-1.01-.98-1.27a118.5 118.5 0 00-4.37-1.55 2.15 2.15 0 00-1.3 0c-.83.26-3.55 1.22-4.38 1.55-.65.25-.97.51-.97 1.27v5.28c0 2.52 1.42 3.47 5.51 5.67.19.1.37.13.49.13zm-.77-3.54c-.26 0-.46-.1-.67-.35l-2.08-2.46a.72.72 0 01-.18-.46c0-.35.28-.6.61-.6.22 0 .4.07.57.28L9.2 12l3.33-5.14c.15-.22.34-.33.54-.33.33 0 .65.22.65.56 0 .15-.1.32-.18.47L9.85 13.1a.72.72 0 01-.62.35z",
                              fill: "#2A9C57",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(7),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "tooltip__block tooltip__top tooltip__block_simple",
                  },
                  [
                    _c("span", { staticClass: "tooltip__block_trigger" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M13.92 7.35l2.59-1.45c-.11-.11-.24-.2-.4-.29l-4.84-2.74A2.58 2.58 0 0010 2.5c-.42 0-.84.13-1.26.37l-1.37.78 6.55 3.7zM10 9.57l2.93-1.66L6.4 4.2 3.9 5.62c-.16.08-.29.17-.4.28L10 9.57zm.48 7.93c.06-.01.1-.04.16-.07l5.37-3.04c.65-.37.99-.75.99-1.74V7.24c0-.2-.01-.36-.05-.5l-6.47 3.68v7.08zm-.96 0v-7.08L3.05 6.73c-.04.15-.05.3-.05.5v5.42c0 .99.35 1.37 1 1.74l5.36 3.04c.05.03.1.06.16.07z",
                              fill: "#2A9C57",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(8),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "tooltip__block tooltip__top tooltip__block_simple",
                  },
                  [
                    _c("span", { staticClass: "tooltip__block_trigger" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "20",
                            height: "20",
                            viewBox: "0 0 20 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M14.93 9.39h1.6c.98 0 1.47-.5 1.47-1.54v-3.3C18 3.5 17.51 3 16.53 3h-1.6c-.98 0-1.47.5-1.47 1.54v3.3c0 1.04.49 1.55 1.47 1.55zm-11.46 0h1.6c.98 0 1.47-.5 1.47-1.54v-3.3C6.54 3.5 6.05 3 5.07 3h-1.6C2.49 3 2 3.5 2 4.54v3.3c0 1.04.49 1.55 1.47 1.55zm5.73 0h1.6c.98 0 1.47-.5 1.47-1.54v-3.3C12.27 3.5 11.78 3 10.8 3H9.2c-.98 0-1.47.5-1.47 1.54v3.3c0 1.04.49 1.55 1.47 1.55zM3.47 17h1.6c.98 0 1.47-.5 1.47-1.54v-3.3c0-1.05-.49-1.55-1.47-1.55h-1.6c-.98 0-1.47.5-1.47 1.54v3.3C2 16.5 2.49 17 3.47 17zm5.73 0h1.6c.98 0 1.47-.5 1.47-1.54v-3.3c0-1.05-.49-1.55-1.47-1.55H9.2c-.98 0-1.47.5-1.47 1.54v3.3c0 1.05.49 1.55 1.47 1.55zm5.73 0h1.6c.98 0 1.47-.5 1.47-1.54v-3.3c0-1.05-.49-1.55-1.47-1.55h-1.6c-.98 0-1.47.5-1.47 1.54v3.3c0 1.05.49 1.55 1.47 1.55z",
                              fill: "#2A9C57",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(9),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("td", { staticStyle: { "white-space": "nowrap" } }, [
            _vm._v("20 Май 2020"),
          ]),
          _vm._v(" "),
          _c("td", [
            _c(
              "div",
              { staticClass: "table__actions d-flex justify-content-end" },
              [
                _c("a", { attrs: { href: "order_edit.html", title: "Edit" } }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M17.25 3.87l.55-.59c.27-.27.27-.66 0-.92l-.17-.2c-.23-.24-.6-.2-.85.05l-.56.57 1.03 1.1zm-8.72 8.24l1.48-.68 6.7-6.98-1.05-1.07-6.69 6.99-.68 1.48c-.06.14.1.32.24.26zM5.38 18h8.9c1.37 0 2.16-.82 2.16-2.46V6.73L15.2 8.01v7.47c0 .83-.42 1.24-.94 1.24H5.4c-.75 0-1.18-.41-1.18-1.24V6.5c0-.82.43-1.25 1.18-1.25h6.56l1.22-1.27h-7.8C3.8 3.97 3 4.79 3 6.42v9.12C3 17.18 3.8 18 5.38 18z",
                          fill: "#06C",
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("a", { attrs: { href: "#", title: "Remove" } }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z",
                          fill: "#515154",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Трекинг №")]),
        _vm._v(" "),
        _c("th", [_vm._v("Доп. услуги")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { attrs: { href: "order_item.html" } }, [_vm._v("54678976543")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip__block_inner" }, [
      _c("p", [_vm._v("Страховка")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip__block_inner" }, [
      _c("p", [_vm._v("Переупаковка")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip__block_inner" }, [
      _c("p", [_vm._v("Подарок")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip__block_inner" }, [
      _c("p", [_vm._v("Раздел")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("a", { attrs: { href: "#" } }, [_vm._v("54678345543")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip__block_inner" }, [
      _c("p", [_vm._v("Страховка")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip__block_inner" }, [
      _c("p", [_vm._v("Переупаковка")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "tooltip__block_inner" }, [
      _c("p", [_vm._v("Раздел")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }